import { SyntheticEvent, useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router';

import { statisticsRoutesConfig } from 'domains/statistics/routes';

export enum StatisticsTab {
  Statistics = 'statistics',
  Raw = 'raw',
}

const TAB_URL_MAP: Record<StatisticsTab, string> = {
  [StatisticsTab.Statistics]: statisticsRoutesConfig.statistics.path,
  [StatisticsTab.Raw]: statisticsRoutesConfig.statisticsRaw.path,
};

export const useStatisticsTabs = () => {
  const navigate = useNavigate();

  const isRawPage = Boolean(
    useMatch(statisticsRoutesConfig.statisticsRaw.path),
  );

  const currentTab = isRawPage ? StatisticsTab.Raw : StatisticsTab.Statistics;

  const handleChangeTab = useCallback(
    (_event: SyntheticEvent, newValue: StatisticsTab) => {
      navigate(TAB_URL_MAP[newValue]);
    },
    [navigate],
  );

  return { currentTab, handleChangeTab };
};
